export default {
  inProgress: 'In progress',
  business: 'Business',
  businesses: 'Businesses',
  brand: 'Brand',
  location: 'Location',
  id: 'ID',
  rol: 'Rol',
  idKbe: 'ID Kbe',
  email: 'Email',
  journey: 'Status',
  journeys: 'Statuses',
  segments: 'Segments',
  extradata: 'Aditional data',
  notes: 'Notes',
  note: 'Note',
  save: 'Save',
  likes: 'Likes',
  cellphone: 'Cellphone',
  habeasData: 'Data protection',
  accepted: 'Accepted',
  rejected: 'Rejected',
  updateDate: 'Updated at',
  unasigned: 'Unasigned',
  enterValue: 'Enter value',
  name: 'Name',
  lastName: 'Last name',
  loadingMoreElements: 'Loading more elements',
  selectApp: 'Select an app',
  pressEnterToSearch: 'Press enter to search',
  edit: 'Edit',
  delete: 'Delete',
  export: 'Export',
  import: 'Import',
  filter: 'Filter',
  areYouSure: '¿Are you sure?',
  documents: 'Documents',
  tasks: 'Tasks',
  responsibles: 'Owners',
  responsible: 'Owner',
  passport: 'Passport',
  citizenCard: 'Citizenship card',
  idCard: 'Id card',
  fullName: 'Full name',
  phone: 'Phone number',
  registerChannel: 'Register Channel',
  roles: 'Roles',
  methods: 'Methods',
  createdAt: 'Creation date',
  reloadList: 'Reload list',
  clear: 'Clear',
  password: 'Password',
  cancel: 'Cancel',
  continue: 'Continue',
  create: 'Create',
  address: 'Address',
  categories: 'Categories',
  updatedBy: 'Updated by',
  date: 'Date',
  value: 'Value',
  people: 'People',
  description: 'Description',
  files: 'Files',
  add: 'Add',
  accept: 'Accept',
  more: 'more',
  today: 'Today',
  tomorrow: 'Tomorrow',
  yesterday: 'Yesterday',
  days: 'Days',
  week: 'Week',
  month: 'Month',
  months: 'Months',
  custom: 'Custom',
  metrics: 'Metrics',
  helpButton: 'Assistance',
  howStart: 'How to start',
  talkWithSupport: 'Client defender',
  unexpectedError: 'Unexpected error',
  done: 'Done',
  status: 'Status',
  unanswered: 'Unanswered',
  inAtention: 'In atention',
  botConversations: 'Conversations with bot',
  transferedConversations: 'Transfered conversations',
  avgResponse: 'Avg. conversation time',
  avgWaitingTime: 'Average waiting time',
  tableConversationsTakenByAgent: 'Table of conversations taken by a user',
  tableConversationsTakenByAgentV4Helper: 'List of users with the total of open conversations ',
  tableAdvisorsV4: 'Conversation detail by user',
  conversationsPerChannel: 'Conversations per channel',
  conversationStatus: 'Conversations status',
  waitTime: 'Waiting Time',
  waitTimeHelper: 'This metric calculates the waiting time by user. It is being calculated by the time that the conversation is created until a user is assigned.',
  conversationTime: 'Conversation time',
  advisorsEndReasons: 'Conversation tags by user',
  averageTalkVolume: 'Average conversation volume',
  averageTalkVolumeHelper: 'Average conversations per hour by day (Average calculated by last 28 days)',
  hireAgents: 'Hire agents 👨🏽‍💻',
  somethingUnexpectedHappenedTtryAgain: 'Something unexpected happened, please try again later',
  reloadMetric: 'Reload metric',
  lastWeek: 'Last week',
  weeks: 'weeks',
  conversationId: 'Conversation ID',
  roomId: 'Room id',
  channel: 'Channel',
  terminationReason: 'Termination Reason',
  userPhone: 'User phone number',
  localUserPhone: 'Local user phone number',
  advisor: 'Advisor',
  finalAdvisorName: 'Final user name',
  conversationActualStatus: 'Conversation actual status',
  totalConversationTimeInMinutes: 'Total conversation time in minutes',
  startDateAndTime: 'Start date and time',
  LastMessageDate: 'Last Message Date',
  enterAPhoneNumber: 'Enter a phone number',
  newConversations: 'New conversations',
  totalConversations: 'Total conversations',
  newConversationsHelper: 'New conversations are counted from the date in which the person sends the first message to your company (We show you a comparison against the previous period, according to the date filter applied).',
  openConversations: 'Open Conversations',
  openConversationsHelper: 'Total of open conversations excluding the ones with bot',
  withoutAdvisor: 'Without user',
  withoutAdvisorHelper: 'Open conversations without a user assigned',
  withoutAnswer: 'With no answer',
  withoutAnswerHelper: 'Open conversations with user and latest message coming from client',
  inAttention: 'In attention',
  inAttentionHelper: 'Open conversations with user and latest message coming from user',
  logIn: 'Log in',
  newPass: 'New password',
  updatePass: 'Update password',
  yourTextHere: 'Your text here',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  last2Weeks: '2 weeks',
  last4Weeks: '4 weeks',
  last8Weeks: '8 weeks',
  download: 'Download',
  userName: 'User name',
  downloading: 'Downloading',
  salesPerformance: 'People state',
  newLeads: 'New leads',
  salesByAdvisor: 'Sales by user',
  notImplemented: 'Not implemented',
  seeByPage: 'see per page',
  confirm: 'Confirm',
  exportDialog1: 'There\'re many reasons why is not a good idea to download personal data',
  insert: 'Add',
  exportDialog2: 'In first place, it\'s a violation of privacy and can be illegal in some cases.',
  exportDialog3: 'Do you want to continue?',
  downloadManually: 'Download manually',
  downloadApi: 'Go to API',
  connectApi: 'You can connect out API to manage your data safely and legally',
  weNeedYoToSignDigitallyOur: 'We need you to digitally sign our',
  dataHandlingAgreement: 'Data handling agreement',
  yourPhone: 'Your phone',
  confirmationCode: 'Confirmation code',
  downloadFile: 'Download file',
  downloadConversations: 'Download Report',
  downloadMessages: 'Download Messages',
  downloadCSAT: 'Download CSAT',
  monthOf: 'Month of',
  nameMonths: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December'
  },
  qualified: 'Qualified',
  responseDate: 'Response date',
  qualification: 'Qualification',
  dateSent: 'Date sent',
  sents: 'Sents',
  promoters: 'Promoters',
  detractors: 'Detractors',
  passive: 'Passive',
  qualificationType: 'Qualification type',
  unidentifiedRating: 'Unidentified rating',
  messagesOf: 'Messages of',
  keybeWebinars: 'Keybe Webinars',
  metricsWebinar: 'Métricas y decisiones estratégicas',
  metricsWebinarDate: '17 de Agosto',
  metricsWebinarTime: '10 AM',
  opportunitiesWebinar: 'Oportunidades ¿Comó crear tu embudo de ventas?',
  opportunitiesWebinarDate: '19 de Agosto',
  opportunitiesWebinarTime: '10 AM',
  campaignWebinar: '¿Cómo crear campañas llamativas?',
  campaignWebinarDate: '16 de Septiembre',
  campaignWebinarTime: '11 AM',
  keybeNewsWebinar: '¿Que hay de nuevo en Keybe?',
  keybeNewsWebinarDate: '16 de Septiembre',
  keybeNewsWebinarTime: '11 AM',
  chatConfigWebinar: '¿Cómo configurar todo lo relacionado con chats?',
  chatConfigWebinarDate: '07 de Septiembre',
  chatConfigWebinarHour: '11 AM',
  autobotsWebinar: 'Pasos para crear tu propio Bot con Keybe\t',
  autobotsWebinarDate: '09 de Septiembre',
  autobotsWebinarHour: '11 AM',
  myKeybeWebinar: '¿Cómo usar mi Keybe para tu negocio?',
  myKeybeWebinarDate: '14 de Septiembre',
  myKeybeWebinarHour: '11 AM',
  skipTutorial: 'Skip tutorial',
  filters: 'Filters',
  greeting: 'Greetings',
  hours: 'Hours',
  socialMedia: 'Social media',
  priceList: 'Price list',
  coverage: 'Coverage',
  shippingTimes: 'Shipping times',
  paymentMethods: 'Payment methods',
  gratitude: 'Gratitude',
  goodbye: 'Goodbye',
  noCampaignsFound: 'No campaigns found',
  buy: 'Buy',
  shippingTimesAndCosts: 'Shipping times and costs',
  orderStatus: 'Order Status',
  cancelOrModifyOrder: 'Cancel/Modify order',
  orderChargeBack: 'Order Charge Back',
  botSettings: 'You can fine-tune some bot settings',
  settings: 'Settings',
  transferBot: 'Send with user automatically when person answers',
  autobotInstagramReaction: 'end with user automatically when there is an IG story reaction',
  botChannelActive: 'Active',
  test: 'Test',
  dealsClosed: 'Closed Deals',
  dealWon: 'Won',
  dealLost: 'Lost',
  dealsBenchmark: 'Won vs. Lost',
  deals: 'Deals',
  newDeals: 'New Deals',
  funnel: 'Funnel',
  quantity: 'Quantity',
  currentPeriod: 'Current Period',
  previousPeriod: 'Previous Period',
  yourCSAT: 'Your CSAT',
  csatHelper: '(Number of satisfied customers (good) / Number of survey responses) x 100 = % of satisfied customers',
  cancelCampaign: 'Campaign canceled',
  report: 'Report',
  selectOpportunity: 'Select Flow',
  crmHeaderTitle: 'Do you think this metrics are great?',
  crmHeaderText: 'Then get ready to see how your money skyrocket in real time with your CRM',
  footerBannerText: 'Happy new year and happy new features',
  learnMore: 'Learn more',
  alreadyExistsCrm: 'This person already exists in your CRM',
  invalidToken: 'Invalid Token',
  iAmAdviser: 'I\'m Adviser',
  iAmCoordinator: 'I\'m Coordinator',
  iAmEntrepreneur: 'I\'m Entrepreneur',
  opinionFormTitle: 'We would like to know your opinion',
  satisfactionTitle: 'How satisfied are you with Keybe\'s service?',
  satisfactionSubtitle: 'From 1 to 5, being 1 very unsatisfied and 5 very satisfied. Only responses from 1 to 5 are allowed',
  wouldYouRecommendKeybe1: 'On a scale of 0 to 10, how likely are you to recommend our business/product/service to friends, colleagues or family?',
  wouldYouRecommendKeybe2: 'Being 0 "I would not recommend it" and 10 "of course I would recommend it',
  keybeSuggestion1: 'Leave us your comments about our service:',
  keybeSuggestion2: 'How would we be more useful to you and your business?',
  send: 'Send',
  thanks: 'Thanks',
  businessAccount: 'Business account',
  botConfigured: 'Bot configured successfully',
  notifications: 'Notifications',
  goToLink: 'Go to link',
  goToYoutube: 'Go to Youtube',
  goToInstagram: 'Go to Instagram',
  goToFacebook: 'Go to Facebook',
  goToTwitter: 'Go to Twitter',
  goToLinkedin: 'Go to Linkedin',
  averageSessionTime: 'Average conversation time',
  averageWaitingTime: 'Average waiting time',
  averageFirstResponseTime: 'Average first response time',
  averageSessionTimeHelper: 'Average time since the first message until conversation is closed.',
  averageWaitingTimeHelper: 'Average waiting time your cutomers have to wait to get a response.',
  averageFirstResponseTimeHelper: 'Average time since the conversation was assigned to an advisor to the time the advisor sends their first response.',
  handoffOnline: 'Handoff online',
  handoffOffline: 'Handoff offline',
  message_suggestion: 'Message suggestion',
  completeForm: 'You must complete the form',
  firstResponseTime: 'First response time'
}
